export const VERSION_MANAGEMENT_GET_VERSION_LIST = 'VERSION_MANAGEMENT_GET_VERSION_LIST'

export const VERSION_MANAGEMENT_SHOW_MODAL = 'VERSION_MANAGEMENT_SHOW_MODAL'
export const VERSION_MANAGEMENT_HIDE_MODAL = 'VERSION_MANAGEMENT_HIDE_MODAL'

export const VERSION_MANAGEMENT_CREATE_NEW_VERSION = 'VERSION_MANAGEMENT_CREATE_NEW_VERSION'
export const VERSION_MANAGEMENT_GET_CHANGE_SETS = 'VERSION_MANAGEMENT_GET_CHANGE_SETS'
export const VERSION_MANAGEMENT_REMOVE_VERSION = 'VERSION_MANAGEMENT_REMOVE_VERSION'
